// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import QuoteAccordion from '../ui-helper-elements/QuoteAccordion'
import HorizontalRule from '../ui-helper-elements/HorizontalRule'
import TotalsHeaderRow from '../rows/totals/TotalsHeaderRow'
import TotalMonthlyListPriceRow from '../rows/totals/TotalMonthlyListPriceRow'
import TotalMonthlyEffectiveDiscountRow from '../rows/totals/TotalMonthlyEffectiveDiscountRow'
import TotalMonthlyRow from '../rows/totals/TotalMonthlyRow'
import TotalOneTimeDiscountRow from '../rows/totals/TotalOneTimeDiscountRow'
import TotalOneTimeCostRow from '../rows/totals/TotalOneTimeCostRow'
import TotalDueAtActivation from '../rows/totals/TotalDueAtActivation'
import Spacer from '../ui-helper-elements/Spacer'
import SpacerThick from '../ui-helper-elements/SpacerThick'
import BottomToolbar from '../rows/misc/BottomToolbar'
import EstimatedAnnualCost from '../rows/totals/EstimatedAnnualCost'
import NotesRow from '../rows/misc/NotesRow'
import EstimatedProratedTotalRow from '../rows/totals/EstimatedProratedTotalRow'
import TotalMonthlyDifferenceRow from '../rows/totals/TotalMonthlyDifferenceRow'
import TotalPayrollRow from '../rows/totals/TotalPayrollRow'
import TotalHeroDiscountRows from '../rows/totals/TotalHeroDiscountRows'
// JS Imports
import { IsForeignCurrencyQuote } from '../../common/helpers.mjs'
// Asset Imports

export default function TotalsSection({
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['TotalSection']

   if (state.user_view == 'Internal') {
      if (!IsForeignCurrencyQuote(state.pricebookId)) {
         if (
            permissions.includes(state.user_role) &&
            state.discountReseller > 0
         )
            return (
               <div>
                  <HorizontalRule></HorizontalRule>
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <Spacer></Spacer>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
               </div>
            )
         else
            return (
               <div>
                  <HorizontalRule></HorizontalRule>
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalHeroDiscountRows />
                  <TotalMonthlyEffectiveDiscountRow></TotalMonthlyEffectiveDiscountRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <TotalMonthlyDifferenceRow></TotalMonthlyDifferenceRow>
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <SpacerThick></SpacerThick>
                  <TotalOneTimeDiscountRow></TotalOneTimeDiscountRow>
                  <TotalOneTimeCostRow></TotalOneTimeCostRow>
                  <SpacerThick></SpacerThick>
                  <TotalDueAtActivation></TotalDueAtActivation>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
                  <BottomToolbar
                     productPerformanceEECount={productPerformanceEECount}
                     setProductPerformanceEECount={setProductPerformanceEECount}
                     productTestAccount={productTestAccount}
                     setProductTestAccount={setProductTestAccount}
                  />
                  <NotesRow />
               </div>
            )
      } else if (IsForeignCurrencyQuote(state.pricebookId)) {
         if (
            permissions.includes(state.user_role) &&
            state.discountReseller > 0
         )
            return (
               <div>
                  <HorizontalRule></HorizontalRule>
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <TotalPayrollRow />
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <Spacer></Spacer>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
               </div>
            )
         else
            return (
               <div>
                  <HorizontalRule></HorizontalRule>
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalHeroDiscountRows />
                  <TotalMonthlyEffectiveDiscountRow></TotalMonthlyEffectiveDiscountRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <TotalMonthlyDifferenceRow></TotalMonthlyDifferenceRow>
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <TotalPayrollRow />
                  <SpacerThick></SpacerThick>
                  <TotalOneTimeDiscountRow></TotalOneTimeDiscountRow>
                  <TotalOneTimeCostRow></TotalOneTimeCostRow>
                  <SpacerThick></SpacerThick>
                  <TotalDueAtActivation></TotalDueAtActivation>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
                  <BottomToolbar
                     productPerformanceEECount={productPerformanceEECount}
                     setProductPerformanceEECount={setProductPerformanceEECount}
                     productTestAccount={productTestAccount}
                     setProductTestAccount={setProductTestAccount}
                  />
                  <NotesRow />
               </div>
            )
      }
   } else {
      if (
         state.monthlyTotal.totalPrice > 0 ||
         state.oneTimeTotal.totalPrice > 0
      ) {
         if (!IsForeignCurrencyQuote(state.pricebookId)) {
            return (
               <QuoteAccordion
                  accordionName='Totals'
                  accordionBodyId='totalsAccordion'
                  collapse={state.user_view == 'External' ? 'true' : 'false'}
               >
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalMonthlyEffectiveDiscountRow></TotalMonthlyEffectiveDiscountRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <TotalMonthlyDifferenceRow></TotalMonthlyDifferenceRow>
                  <TotalHeroDiscountRows />
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <SpacerThick></SpacerThick>
                  <TotalOneTimeDiscountRow></TotalOneTimeDiscountRow>
                  <TotalOneTimeCostRow></TotalOneTimeCostRow>
                  <SpacerThick></SpacerThick>
                  <TotalDueAtActivation></TotalDueAtActivation>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
                  <BottomToolbar
                     productPerformanceEECount={productPerformanceEECount}
                     setProductPerformanceEECount={setProductPerformanceEECount}
                     productTestAccount={productTestAccount}
                     setProductTestAccount={setProductTestAccount}
                  />
                  <NotesRow></NotesRow>
               </QuoteAccordion>
            )
         } else if (IsForeignCurrencyQuote(state.pricebookId)) {
            return (
               <QuoteAccordion
                  accordionName='Totals'
                  accordionBodyId='totalsAccordion'
                  collapse={state.user_view == 'External' ? 'true' : 'false'}
               >
                  <TotalsHeaderRow></TotalsHeaderRow>
                  <TotalMonthlyListPriceRow></TotalMonthlyListPriceRow>
                  <TotalMonthlyEffectiveDiscountRow></TotalMonthlyEffectiveDiscountRow>
                  <TotalMonthlyRow></TotalMonthlyRow>
                  <TotalMonthlyDifferenceRow></TotalMonthlyDifferenceRow>
                  <EstimatedProratedTotalRow></EstimatedProratedTotalRow>
                  <TotalPayrollRow />
                  <SpacerThick></SpacerThick>
                  <TotalOneTimeDiscountRow></TotalOneTimeDiscountRow>
                  <TotalOneTimeCostRow></TotalOneTimeCostRow>
                  <SpacerThick></SpacerThick>
                  <TotalDueAtActivation></TotalDueAtActivation>
                  <EstimatedAnnualCost></EstimatedAnnualCost>
                  <BottomToolbar
                     productPerformanceEECount={productPerformanceEECount}
                     setProductPerformanceEECount={setProductPerformanceEECount}
                     productTestAccount={productTestAccount}
                     setProductTestAccount={setProductTestAccount}
                  />
                  <NotesRow></NotesRow>
               </QuoteAccordion>
            )
         }
      }
   }
   return null
}
